import { useDropzone } from 'react-dropzone';
import { Upload } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button, LoadingSpinner } from '../ui';

interface FileUploaderProps {
  onDrop: (files: File[]) => void;
  isLoading?: boolean;
}

const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

function FileUploader({ onDrop, isLoading }: FileUploaderProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    maxSize: 30 * 1024 * 1024, // 30MB
    onDrop,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        className={cn(
          'border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors duration-200',
          isDragActive
            ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/10'
            : 'border-gray-300 hover:border-primary-500 dark:border-gray-600'
        )}
      >
        <input {...getInputProps()} />
        <Upload className="mx-auto h-12 w-12 text-gray-400 mb-4" />
        <p className="text-base text-gray-600 dark:text-gray-300">
          Arraste e solte um arquivo aqui
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">ou</p>
        <Button variant="secondary" className="mt-4" onClick={e => e.preventDefault()}>
          Selecionar arquivo
        </Button>
        <p className="mt-2 text-xs text-gray-500">PDF, JPG ou PNG até 30MB</p>
      </div>

      {isLoading && (
        <div className="mt-4 flex items-center justify-center">
          <LoadingSpinner size="sm" className="mr-2" />
          <span className="text-sm text-gray-600">Enviando arquivo...</span>
        </div>
      )}
    </div>
  );
}

export default FileUploader;
